import ApplicationAdapter from './application';

export default class CombinedCourseAdapter extends ApplicationAdapter {
  urlForQuery(query) {
    if (query.organizationId) {
      const { organizationId } = query;
      delete query.organizationId;
      return `${this.host}/${this.namespace}/organizations/${organizationId}/combined-courses`;
    }
    return super.urlForQuery(...arguments);
  }
}
